import * as React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { FormControl, InputLabel } from '@mui/material';

import AppIcons from '../../assets/images/icons';

import './downloadBrochurePopup.scss'
// import { Link } from 'react-router-dom';
import { showSnackbar } from '../Notification/Snackbar';
import { postQuery } from '../../services/api/enquires';
import { Grid } from '@mui/material';



function DownloadBrochurePopup(props) {
  const { brochureName = '', icon = '', title = '', brochureLink = '' } = props;
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({});

  /**
 * sets the form data 
 * @param {string} name the name of the field
 * @param {string} value  the value of the field
 */
  const setFormValue = (name, value) => {
    const formDataAs = { ...formData };
    setFormData({ ...formDataAs, ...{ [name]: value } });
  }

  /**
   * Validates the form and returns true if valid
   * @returns boolean
   */
  const isValidForm = () => {
    let isValid = false;
    if (formData && formData.name &&
      formData.email &&
      formData.phoneNumber) {
      isValid = true;
    }
    return isValid;
  }

  /**
   * On submit the form
   */
  const onSubmit = () => {
    if (isValidForm()) {
      // Submitting data to backend for registration
      setIsLoading(true);

      const formPostData = {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        query: formData.query
      }

      postQuery(formPostData).then((data) => {
        if (data.success) {
          setFormData(null);
          handleClose();
          showSnackbar().success(data.message)
        } else {
          showSnackbar().failure(data.message)

        }
      }).finally(() => setIsLoading(false));


      brochureDownload();





    }
  };
  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const brochureDownload = () => {
    const pdfUrl = brochureLink;
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = brochureName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };




  return (
    <div className='download-brochure-wrp f-wrp'>

      {brochureLink ? <Link className='pdf-download-btn' to={'/'} onClick={handleClickOpen}>
        {icon}
        {title}
      </Link> : null}


      <Dialog id="contact-modal" className='download-brochure-popup' open={open} onClose={handleClose}>
        <DialogContent>
          <DialogActions className='float-btn'>
            <span onClick={handleClose}><svg width="25" height="25" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.53341 25.8334L6.66675 23.9667L14.1334 16.5001L6.66675 9.03341L8.53341 7.16675L16.0001 14.6334L23.4667 7.16675L25.3334 9.03341L17.8667 16.5001L25.3334 23.9667L23.4667 25.8334L16.0001 18.3667L8.53341 25.8334Z" fill="#FFFFFF" />
            </svg>
            </span>
          </DialogActions>
          <div className='contct-grid-wrp f-wrp'>
            <div className='img-blk f-wrp'>
              <span><img src={AppIcons.contactPopupSideImage} alt="building night view" /></span>
            </div>
            <div className='contct-form-wrp popup-content-box f-wrp'>

              <div className='title-box f-wrp'>
                <h1>Join Our Investor Circle for Market Updates & Opportunities</h1>
                <p>Receive our latest brochure, along with handpicked market intelligence and upcoming investment launches. No spam—just value.</p>
              </div>



              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    autoFocus
                    focused
                    margin="dense"
                    id="name"
                    name="name"
                    label="Name"
                    type="text"
                    fullWidth
                    className='custom-textfield'
                    variant="outlined"
                    required
                    onChange={(e) => setFormValue('name', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    focused
                    margin="dense"
                    id="email"
                    name="email"
                    label="Email Address"
                    type="email"
                    fullWidth
                    className='custom-textfield'
                    variant="outlined"
                    required
                    onChange={(e) => setFormValue('email', e.target.value)}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6}> */}
                {/* <TextField
                    focused
                    margin="dense"
                    id="phone"
                    name="phoneNumber"
                    label="Contact Number"
                    type="number"
                    fullWidth
                    className='custom-textfield'
                    variant="outlined"
                    required
                    onChange={(e) => setFormValue('phoneNumber', e.target.value)}
                  /> */}

                <Grid item xs={12} sm={6} md={6}>
                  <FormControl className='custom-textfield phoneNumberWithIcon' fullWidth margin="dense" required>
                    <InputLabel shrink htmlFor="phone-input">Contact Number</InputLabel>
                    <PhoneInput
                      id="phone"
                      name="phoneNumber"
                      required
                      // value={formData.phoneNumber || ''}
                      onChange={(value) => setFormValue('phoneNumber', value)}
                      defaultCountry="AE"
                      className="custom-phone-input"
                    />

                  </FormControl>
                </Grid>


                {/* </Grid> */}

                <Grid item xs={12} sm={12} md={12} className='min-height150'>
                  <TextField
                    focused
                    id="Message"
                    name="query"
                    // label="Message"
                    multiline
                    placeholder='Message..'
                    minRows={1.3}
                    maxRows={5}
                    fullWidth
                    className='custom-textarea'
                    // defaultValue={`${defaultComment}`}
                    variant="outlined"
                    onChange={(e) => setFormValue('query', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Button disabled={!isValidForm()} onClick={onSubmit}>{isLoading ? 'Downloading...' : 'Download PDF'}</Button>
                </Grid>
              </Grid>

            </div>
          </div>

        </DialogContent>

      </Dialog>
    </div>
  );
}

DownloadBrochurePopup.propTypes = {
  brochureName: PropTypes.any,
  icon: PropTypes.any,
  title: PropTypes.any,
  brochureLink: PropTypes.any,
}
export default DownloadBrochurePopup
